var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40ZM20.64 15.64C21.1923 15.64 21.64 16.0877 21.64 16.64L21.64 30.64C21.64 31.1923 21.1923 31.64 20.64 31.64H19C18.4477 31.64 18 31.1923 18 30.64L18 16.64C18 16.0877 18.4477 15.64 19 15.64H20.64ZM20.64 9C21.1923 9 21.64 9.44771 21.64 10V11.64C21.64 12.1923 21.1923 12.64 20.64 12.64H19C18.4477 12.64 18 12.1923 18 11.64V10C18 9.44771 18.4477 9 19 9H20.64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon_Info.0ad43aed6cd19e354236b04017248fed.svg";
export { ForwardRef as ReactComponent };